export default __webpack_public_path__ + "static/media/23t.736f39d5.jpg";